<template>
  <!-- 방문예약 신청안내 화면 -->
  <v-card class="ma-4 word_keeper">
    <v-toolbar dense flat color="white">
      <v-toolbar-title class=" font-weight-bold" style="min-width:140px;">
        <v-icon class="mr-2">mdi-monitor-eye</v-icon>방문예약 신청 안내
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="mr-4 ml-4"></v-divider>
    <v-toolbar dense flat color="white">
      <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
        방문예약신청은 이렇게 하세요.
      </v-card-subtitle>
    </v-toolbar>
    <v-card-subtitle class="pt-2 pb-2 text-caption grey--text text-justify text--darken-2 font-weight-bold">
      <div class="mb-1 d-flex">1.&nbsp;<div>방문예약 시 물품반입 신청을 같이 신청할 수 있습니다.</div></div>
      <div class="mb-1 d-flex">2.&nbsp;<div>방문예약 신청과 물품반입 신청을 따로 운영 중입니다.</div></div>
      <div class="d-flex">3.&nbsp;<div>사전에 {{$store.state.CustomInfo.SiteNm}} 담당자와 협의하여 접견실만 이용할 경우 방문예약은 따로 신청하지 않아도 됩니다.</div></div>
    </v-card-subtitle>
    <v-divider class="mr-4 ml-4"></v-divider>


    <div class="flex-wrap d-flex justify-center mt-10 mb-4">     
      <img src="../assets/SKST/Guide/guide_1_1.svg" style="height:200px; border-radius: 10px;"/>
      <img src="../assets/SKST/Guide/guide_1_2.svg" style="height:200px; border-radius: 10px;"/>
      <img src="../assets/SKST/Guide/guide_1_3.svg" style="height:200px; border-radius: 10px;"/>
      <img src="../assets/SKST/Guide/guide_1_4.svg" style="height:200px; border-radius: 10px;"/>
    </div>


    <v-card-text align="center">
      <v-divider class="mb-4"></v-divider>
      <v-btn @click="$router.push({name: 'MainBoard'});" width="100px" text class="mr-2"><v-icon class="mr-2">dashboard</v-icon>홈</v-btn>
      <v-btn @click="$router.push({name: 'VisitReq'});" width="100px" dark class="ml-2"><v-icon class="mr-2">mdi-open-in-new</v-icon>신청</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
// import {mapState} from "vuex";

export default {
  
  components: {
    // ...mapState(["isLoginTime"]),
  },
  data: () => ({
  }),
  computed: {  
  },
  created() {
  },
  mounted() {
  },

  methods : {
  }
}
</script>